import { ValidationService } from 'aspnet-client-validation';

// Replaces jquery.validate + unobtrusive: reads the same data-val-* attributes the
// tag helpers render and uses the same CSS classes (input-validation-error,
// field-validation-error, validation-summary-errors). Hidden fields are skipped,
// as jquery.validate did.
const service = new ValidationService();

// By default the library also stops other submit listeners until the form is
// valid. Letting them run means a page's own checks (recruiter, Froala text,
// application emails) report alongside the field errors, as with jquery.validate.
service.preValidate = (submitEvent) => submitEvent.preventDefault();

// data-val-requiredone: at least one input sharing the element's name has a value
// (a ticked checkbox or radio, or a non-empty select/text input).
service.addProvider('requiredone', (value, element) => {
  const group = (element.form ?? document).querySelectorAll(`[name="${element.name}"]`);

  return [...group].some((input) => (input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value !== ''));
});

export function enhanceValidation() {
  service.bootstrap({ watch: true });
}

// What $('[name=x]').rules('add', { required: true, messages: { required } }) did
// for the checkbox and radio groups on the job pages.
export function requireOne(name, message) {
  const inputs = document.querySelectorAll(`[name="${name}"]`);

  inputs.forEach((input) => {
    input.dataset.val = 'true';
    input.dataset.valRequiredone = message;
  });

  if (inputs.length) {
    service.scan(inputs[0].form ?? document.body);
  }
}
